/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import { FiMaximize2 } from "react-icons/fi";
import "./CellDetails.scss";

const CellDetails = ({ job, dictJobs, onExpandClick }) => {

  // Prepare the data rows to display
  const detailsData = [
    { label: "Job Name", value: job.Name },
    { label: "Scheduler Name", value: job.SchedulerName },
    { label: "Status", value: job.Status },
    { label: "Job Type", value: job.JobType },
    { label: "Command Line", value: job.CommandLine },
    { label: "Full Command Line", value: job.FullCommandLine },
    { label: "AlgoVars Filepath", value: job.AlgoVarsFilepath },
    { label: "Frequency", value: job.Frequency },
    { label: "Resources", value: job.Resources },
    { label: "Min Start Time", value: job.MinStartTime },
    {
      label: "Dependencies",
      value: job.Dependencies.map((dep, index) => {
        // Find the dependency job in dictJobs to get its status
        const depJob = dictJobs[job.SchedulerName]?.find(j => j.Name === dep);
        const depStatus = depJob?.Status || "unknown";
        
        return (
          <div key={index} className="dependency-item">
            {depJob && (
              <span className={`status-pill status-${depStatus.toLowerCase()}`} style={{height: '12px', lineHeight: '12px'}}>
                {depStatus}
              </span>
            )}
            <span className="item-name">{dep}</span>
            </div>
        );
      }),
    },
    {
      label: "Children",
      value: job.Children.map((child, index) => {
        // Find the child job in dictJobs to get its status
        const childJob = dictJobs[job.SchedulerName]?.find(j => j.Name === child);
        const childStatus = childJob?.Status || "unknown";
        
        return (
          <div key={index} className="dependency-item">
            {childJob && (
              <span className={`status-pill status-${childStatus.toLowerCase()}`} style={{height: '12px', lineHeight: '12px'}}>
                {childStatus}
              </span>
            )}
            <span className="item-name">{child}</span>
            </div>
        );
      }),
    },
  ].filter((item) => item.value);

  return (
    <div className="cell-details">
      <div className="cell-details-header">
        <div className="cell-details-header-flexible">
          <span className="cell-details-jobName">{job.Name}</span>
        </div>
        <div className="cell-details-controls">
          <button
            className="cell-details-maximize"
            onClick={onExpandClick}
            aria-label="Expand Details"
          >
            <FiMaximize2 />
          </button>
        </div>
      </div>
      <div className="cell-details-container">
        <table>
          <tbody>
            {detailsData.map((item, index) => (
              <tr key={index}>
                <td>{item.label}</td>
                <td>
                  {Array.isArray(item.value) ? (
                    item.value
                  ) : (
                    <div>{item.value}</div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CellDetails;
